import styled from "@emotion/styled";

import { ReactComponent as CellsIcon } from "@src/assets/cells.svg";
import { zIndex } from "@src/styles";

const StyledBaseLayout = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: clip;
  width: 100%;
  min-height: 100vh;
  background-color: var(--ld-col-neutral-010);

  &[data-secondary="true"] {
    background-color: var(--ld-col-vy-200);
  }

  &[data-primary="true"] {
    background-color: var(--ld-col-wht);
  }

  > main {
    display: flex;
    flex-direction: column;
    position: relative;
    flex: 1;
    z-index: ${zIndex.baseLayoutMain};
  }
`;

const StyledCells = styled(CellsIcon)`
  position: absolute;
  bottom: -30vw;
  left: -48vw;
  width: 200%;
  height: auto;
`;

export { StyledBaseLayout, StyledCells };
